//# sourceURL=symloading.js
(function ($) {

    $.fn.symloading = function (method) {
        var settings;

        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.symloading');
        }

    };

    var methods = {
        init: function (options) {
            return this.each(function () {
                var $this = $(this),
                    settings = $this.data('symloading');

                // If we could't grab settings, create them from defaults and passed options
                if (typeof settings === 'undefined') {
                    var guid = $.newGuid(),
                        defaults = {
                            guid: guid,
                            type: 'alert-es',
                            message: 'Cargando',
                            dialog: {
                                dialogSize: 'm',
                                progressType: ''
                            },
                            onHide: null,
                            spinnerbig: {
                                icon: 'gear-lavender-big.gif'
                            },
                            spinnermedium: {
                                icon: 'ajax-loader-full.gif'
                            },
                            top: null
                        };

                    settings = $.extend({}, defaults, options);

                    // Save our newly created settings
                    $this.data('symloading', settings);
                } else {
                    // We got settings, merge our passed options in with them (optional)
                    settings = $.extend({}, settings, options);

                    // If you wish to save options passed each time, add:
                    // $this.data('pluginName', settings);
                }

                $this.symloading("show", settings);

            });
        },

        input: function () {
            var $this = $(this);
            var settings = $this.data("symloading");
            if (settings !== undefined) return;
            
            opts = {
                type: "input"
            };
            $this.symloading(opts);
        },

        blink: function () {
            var $this = $(this);
            opts = {
                type: "blink"
            };
            $this.symloading(opts);
        },

        btn: function (mensaje) {
            var $this = $(this);
            opts = {
                type: "btn",
                message: mensaje
            };
            $this.symloading(opts);
        },

        fa: function () {
            var $this = $(this);
            opts = {
                type: "fa"
            };
            $this.symloading(opts);
        },

        show: function (settings) {
            var loader = $('<div class="symloading-spinner-loader"></div>'),
                rec = this.get(0).getBoundingClientRect(),
                heightWidth = Math.min(Math.min(rec.height, 250), Math.min(rec.width, 250)),
                top = settings.top || rec.top + (rec.height / 2) - (heightWidth / 2) + window.scrollY,
                left = rec.left + (rec.width / 2) - (heightWidth / 2) + window.scrollX;

            $(loader)
                .addClass("symloading-for-" + settings.guid)
                .css("height", heightWidth)
                .css("width", heightWidth)
                .css("top", settings.top || top)
                .css("left", left);

            switch (settings.type) {
                case "alert":
                    settings.alert = $.dialog({
                        icon: 'fa fa-spinner fa-spin',
                        title: 'Working!',
                        content: 'Sit back, we are processing your request!',
                        closeIcon: false
                    });
                    break;
                case "alert-es":
                    settings.alert = $.dialog({
                        icon: 'fa fa-spinner fa-spin',
                        title: 'Un momento',
                        content: 'Estamos procesando su solicitud',
                        closeIcon: false
                    });
                    break;
                case "blink":
                    $(this).addClass("symloading-blink");
                    $(this).addClass("symloading-for-" + settings.guid);
                    break;
                case "button":
                case 'btn':
                    var $this = $(this),
                        loadingText = '<i class="fas fa-spinner fa-spin"></i> ' + settings.message;

                    if ($(this).html() !== loadingText) {
                        $this.data('original-text', $(this).html());
                        $this.html(loadingText);
                    }
                    break;
                case "fa":
                    $(this).data('faclass', $(this).attr("class"));
                    $(this).attr("class", "fas fa-circle-notch fa-spin fa-fw");
                    break;
                case "input":
                    $(this).after('<i id="{0}" class="fas fa-circle-notch fa-spin fa-fw"></i>'.format(settings.guid));
                    var position = $(this).position();
                    $('#' + settings.guid)
                        .css("position", "absolute")
                        .css("top", position.top + $(this).height() - $('#' + settings.guid).height())
                        .css("left", $(this).width());
                    break;
                case "opacity":
                    $(this).addClass("symloading-opacity");
                    break;
                case "spinner":
                    $(this).addClass("symloading-spinner");
                    $("body").append(loader);
                    break;

                default:
                    console.warn('type ' + settings.type + ' does not exits in symloading');

            }
        },

        spinner: function (opts) {
            opts = opts || {};
            var $this = $(this);
            opts.type = "spinner"
            $this.symloading(opts);

        },

        hide: function (o) {
         
            var $this = $(this)
            settings = $this.data('symloading');
            if (typeof settings === 'undefined') { return; }
            switch (settings.type) {
                case "alert":
                case "alert-es":
                    settings.alert.close();
                    break;
                case "blink":
                    $(this)
                        .removeClass("symloading-blink")
                        .removeClass('symloading-for-' + settings.guid);
                    break;
                case 'button':
                case 'btn':
                    $(this).html($this.data('original-text'));
                    break;
                case "fa":
                    $(this).attr("class", $(this).data('faclass'));
                    break;
                case "input":
                    $('#' + settings.guid).remove();
                    break;
                case "spinner":
                    $(this).removeClass("symloading-spinner");
                    $('.symloading-for-' + settings.guid).remove();
                    break;
                case "opacity":
                    $(this).removeClass("symloading-opacity");
                    break;
            }

            $this.removeData('symloading');
        }

    };
})(jQuery);
//# sourceURL=symloading.js